export const getErrorMessages = (t) => ({
  ERROR_TITLE: t('payment_error'),
  ERROR_MESSAGE: t('an_error_occurred_during_the_payment_process'),
  ERROR_TITLE_429: t('payment_error_429'),
  ERROR_MESSAGE_429: t('too_many_payment_attempts'),
});
